import {createAction} from 'redux-actions';
import * as Constants from './constants';

export const uploadFileCSV = createAction(Constants.AUTO_CREATE_MGD_UPLOAD_FILE.REQUEST, (file) => (file));
export const clearState = createAction(Constants.TRANSACTION_UPLOAD_FILE_CLEAR_STATE,  () => ({}));

export const uploadFileCSVSuccess = createAction(Constants.AUTO_CREATE_MGD_UPLOAD_FILE.SUCCESS, (info) => (info));
export const uploadFileCSVRequest = createAction(Constants.AUTO_CREATE_MGD_UPLOAD_FILE.REQUEST, (info) => (info));
export const uploadFileCSVFailed = createAction(Constants.AUTO_CREATE_MGD_UPLOAD_FILE.FAILED, (info) => (info));
